"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFormTravelRoomsToSearchCriteriaInputRooms = exports.mapFormTravelRoomsToSearchCriteriaInputTravellers = exports.mapSearchControlTravelRoomsToFormTravelRooms = void 0;
const components_common_dob_input_1 = require("@hotelplan/components.common.dob-input");
const mapSearchControlTravelRoomsToFormTravelRooms = (travellers, rooms, travellersDistribution) => {
    return {
        adults: travellers.adults || 0,
        childrenDobs: (travellers.childrenDobs || []).map(components_common_dob_input_1.convertISOStrToDOBStr),
        rooms: rooms || 0,
        travellersDistribution: travellersDistribution
            ? {
                rooms: travellersDistribution.rooms.map(room => ({
                    adultsAmount: room.adultsAmount,
                    childrenIdx: room.childrenIdx,
                })),
            }
            : null,
    };
};
exports.mapSearchControlTravelRoomsToFormTravelRooms = mapSearchControlTravelRoomsToFormTravelRooms;
const mapFormTravelRoomsToSearchCriteriaInputTravellers = (travelRooms) => {
    return {
        adults: (travelRooms === null || travelRooms === void 0 ? void 0 : travelRooms.adults) || 0,
        childrenDobs: ((travelRooms === null || travelRooms === void 0 ? void 0 : travelRooms.childrenDobs) || []).map(components_common_dob_input_1.convertDOBStrToISOStr),
    };
};
exports.mapFormTravelRoomsToSearchCriteriaInputTravellers = mapFormTravelRoomsToSearchCriteriaInputTravellers;
const mapFormTravelRoomsToSearchCriteriaInputRooms = (travelRooms) => {
    return (travelRooms === null || travelRooms === void 0 ? void 0 : travelRooms.rooms) || 0;
};
exports.mapFormTravelRoomsToSearchCriteriaInputRooms = mapFormTravelRoomsToSearchCriteriaInputRooms;
//# sourceMappingURL=TravelRooms.mappers.js.map